import { motion } from "framer-motion";

// Scroll-reveal wrapper — replaces the old useReveal + IntersectionObserver hook.
export default function Reveal({ children, delay = 0, y = 24, as = "div", style, ...rest }) {
  const Component = motion[as] || motion.div;
  return (
    <Component
      initial={{ opacity: 0, y, scale: 0.97 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ type: "spring", stiffness: 120, damping: 16, mass: 0.6, delay }}
      style={style}
      {...rest}
    >
      {children}
    </Component>
  );
}
